import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React from 'react';
import { getStockColor, StockDetail } from '.';
import { optionsGoldSilver } from './config';

interface GOLD_SILVER_CHART_PROPS {
  stockData: Array<StockDetail>;
  showTimeInToolTip?: boolean;
  gram: string;
  carat?: string;
}

export const getMappedValue: Record<string, number> = {
  '1gm': 1,
  '1kg': 1000,
};

export const GoldSilverChart: React.FC<GOLD_SILVER_CHART_PROPS> = ({
  stockData,
  showTimeInToolTip = false,
  carat = '',
  gram,
}) => {
  const stockColor = getStockColor(stockData);
  const stockOptions = optionsGoldSilver(
    [...stockData],
    stockColor,
    showTimeInToolTip,
    gram,
    carat
  );
  return (
    <div className="w-full">
      <HighchartsReact highcharts={Highcharts} options={{ ...stockOptions }} />
    </div>
  );
};
